import { createSelector } from 'reselect'

const selectRelate = state => state.related

const selectRelated = createSelector(
  selectRelate,
  related => related.related
)

const selectSuggested = createSelector(
  selectRelate,
  related => related.suggested
)

const selectFetchingRelated = createSelector(
  selectRelate,
  related => related.isFetching
)

const getData = (state, props) => {
  return state.related[props.relatedType]
}

const getIsFetching = (state, props) =>
  state.related.isFetching[props.relatedType]

const selectData = createSelector(
  getData,
  data => data
)

const selectIsFetching = createSelector(
  getIsFetching,
  isFetching => isFetching
)

export {
  selectRelated,
  selectSuggested,
  selectFetchingRelated,
  selectData,
  selectIsFetching
}



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/selectors.js